<template>
	<FormKit
		preserve
		type="form"
		:actions="false"
		form-class="flex flex-auto"
		role="search"
		aria-label="Napište, co hledáte za produkt..."
		@submit="emit('submitSearch')"
	>
		<FormKit
			ref="searchInputRef"
			v-model="vModel"
			type="search"
			label="Hledat"
			:maxlength="100"
			:classes="{
				outer: 'flex flex-auto',
				wrapper: 'flex flex-auto',
				inner: `bg-background-secondary w-full rounded-lg !px-3 shadow-none !max-w-none ${inputBorder ? '!border-border-select' : '!border-border-secondary'} ${focusInputBorder && hasFocus && '!border-border-select'}`,
				input: 'py-[0.7rem] flex-auto !text-body-m',
				label: 'sr-only'
			}"
			:auto-focus="focus || false"
			input-border
			placeholder="Napište, co hledáte za produkt..."
			@focus="handleInputFocus"
			@focusout="hasFocus = false"
		>
			<template #prefixIcon>
				<NuxtIcon name="search" filled class="text-icon-primary text-[1.375rem] shrink-0" />
			</template>
			<template #suffixIcon>
				<div class="flex gap-1">
					<button
						v-if="vModel.length"
						type="button"
						aria-label="Smazat hledaný výraz"
						class="shrink-0 rounded-full bg-background-secondary transition-colors hover:bg-background-tertiary"
						@click="vModel = ''"
					>
						<NuxtIcon name="x" filled class="text-icon-tertiary text-[1.5rem] [&_circle]:hidden" />
					</button>
					<button
						v-if="showButton"
						type="submit"
						class="btn btn-primary btn-sm shrink-0 typo-body-caption"
					>
						Hledat
					</button>
				</div>
			</template>
		</FormKit>

		<FormKit
			type="submit"
			label="Hledat"
			:classes="{
				outer: 'flex-none self-center',
				wrapper: 'flex-none',
				input: 'sr-only pl-1',
			}"
		/>
	</FormKit>
</template>

<script setup lang="ts">
	type Props = {
		focus?: boolean;
		modelValue: string | string[];
		showButton?: boolean;
		inputBorder?: boolean;
		focusInputBorder?: boolean;
	};

	type Emits = {
		(e: 'update:modelValue', value: string | string[]): void;
		(e: 'submitSearch'): void;
	};

	const props = defineProps<Props>();
	const emit = defineEmits<Emits>();
	const vModel = useVModel(props, 'modelValue', emit);
	const hasFocus = ref(false);

	function handleInputFocus() {
		hasFocus.value = true;
		trackHeaderEvent('search_field_top', String(vModel.value));
	}
</script>
